<template>

    <div class="image_too_large_modal">
        <div class="image_too_large_modal--inner">
            <div class="close-too-large-modal" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </div>
            <div class="redCardSvg">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">

                    <defs>
                    </defs>
                    <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
                        <path d="M 56.35 62.537 l 0.63 -3.584 c 0.575 -3.271 3.722 -5.477 6.993 -4.902 h 0 c 3.271 0.575 5.477 3.722 4.902 6.993 l -1.345 7.647 L 64.085 90 h -7.517 C 53.808 80.129 53.398 70.884 56.35 62.537 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(253,218,170); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                        <path d="M 54.932 62.504 c 3.739 0 6.771 -3.031 6.771 -6.771 V 6.771 C 61.703 3.031 58.672 0 54.932 0 H 36.04 c -4.052 0 -7.337 3.285 -7.337 7.337 v 47.829 c 0 4.052 3.285 7.337 7.337 7.337" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(247,62,66); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                        <path d="M 29.703 55.167 V 7.337 C 29.703 3.285 32.988 0 37.04 0 h -8.669 c -4.052 0 -7.337 3.285 -7.337 7.337 v 47.829 c 0 4.052 3.285 7.337 7.337 7.337 h 8.669 C 32.988 62.504 29.703 59.219 29.703 55.167 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(229,57,61); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                        <path d="M 56.358 62.491 l -9.951 0.013 l -1.841 -11.575 c -0.495 -3.115 -3.449 -5.259 -6.565 -4.763 c -0.432 0.069 -0.843 0.189 -1.233 0.346 c -0.33 0.941 -1.935 1.809 -1.769 2.858 l 3.257 20.11 c 0.792 4.45 3.371 8.617 6.587 12.481 c 1.49 2.223 1.068 5.008 1.725 8.04 l 10 0 L 56.358 62.491 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(253,218,170); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                        <path d="M 39.669 69.491 l -3.174 -19.958 c -0.167 -1.049 -0.057 -2.081 0.273 -3.022 c -2.424 0.976 -3.957 3.535 -3.53 6.219 l 2.923 18.381 c 0.729 4.098 2.856 7.859 5.818 11.417 c 1.372 2.047 2.144 4.679 2.75 7.471 h 4.243 c -0.658 -3.032 -1.496 -5.889 -2.986 -8.112 C 42.77 78.024 40.461 73.941 39.669 69.491 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(254,196,120); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                        <path d="M 38.612 54.644 l 4.703 -0.864 l -0.552 -3.472 c -0.301 -1.893 -2.096 -3.196 -3.989 -2.895 c -0.431 0.069 -0.832 0.215 -1.19 0.422" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(254,196,120); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                    </g>
                </svg>
            </div>
            Tamaño de imagen es demasiado grande<br>
            Por favor por debajo de 5MB. Gracias.
        </div>
    </div>
    
</template>

<script>
    export default {

        methods: {
            closeModal() {
                this.$emit('close-modal');
            }
        }

    }
</script>

<style lang="less">

.image_too_large_modal {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 100;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        backdrop-filter: blur(10px);
        z-index: -1;
    }

    .image_too_large_modal--inner {
        background: #fff;
        border-radius: var(--radius_global);
        padding: 2rem;
        position: relative;
        z-index: 1;
        border: 3px solid var(--dark_blue);
        text-align: center;
        color: var(--dark_blue);
        font-weight: 600;
        font-size: 1.2rem;
    }

    .close-too-large-modal {
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(30%,-50%);
        width: 35px;
        height: 35px;
        background: var(--button_gradient_orange);
        border: 2px solid var(--dark_blue);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        svg {
            fill: white;
            display: block;
            width: 30px;
            height: auto;
        }
    }
}

.redCardSvg {
    text-align: center;

    svg {
        width: 70px;
        height: auto;
        display: inline-block;
        padding: 0;
        margin-bottom: 1rem;
    }
}
</style>